import api from "../apiInstance";
import { ChatChannelData, MessagesListResponse, UserChannelElementListResponse } from "./interfaces/Channel";
import { MessageResponse } from "./interfaces/MessageResponse";
import { PaginatedListResponse } from "./interfaces/paging";

export const getMessages = async (channelId: number, skip: number, take: number): Promise<MessagesListResponse> => {
    const res = await api.get<PaginatedListResponse<MessageResponse>>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/channel/' + channelId + "?skip=" + skip +"&take=" + take);
    return res.data;
}

export const markChatMessagesAsRead = async (channelId: number): Promise<number> => {
    const res = await api.post<number>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/mark_channel_messages_read/' + channelId);
    return res.data;
}

export const markMessageAsRead = async (messageId: number): Promise<number> => {
    const res = await api.post<number>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/mark_message_read/' + messageId);
    return res.data;
}

export const getUserChannels = async (skip: number, take: number, getBuyerChannels: boolean): Promise<PaginatedListResponse<UserChannelElementListResponse>> => {
    let channelsUrlString = ""
    if (getBuyerChannels) {
        channelsUrlString = "user_buyer_channels";
    } else {
        channelsUrlString = "user_seller_channels";
    }

    const res = await api.get<PaginatedListResponse<UserChannelElementListResponse>>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/' + channelsUrlString + '?skip=' + skip +"&take=" + take)

    return res.data;
}

export const getChannelData = async (channelId: number): Promise<ChatChannelData> => {
    const res = await api.get<ChatChannelData>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/channel_data/' + channelId);
    return res.data;
}

export const makeTestRequest = async (): Promise<any> => {
    const res = await api.get<any>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/test_send_message');
    return res.data;
}